import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Title as DefaultTitle } from '../../containers/DefaultStyles/Shared';

const Text = styled(DefaultTitle)`
    span {
        font-weight: 800;
        color: #ff245e;
        cursor: pointer;
    }
`;

const Title = props => (
    <Text
        isLongText={props.isLongText}
        isExtraLongText={props.isExtraLongText}
        onClick={e => props.onPartnerClick(true, e)}
        dangerouslySetInnerHTML={{
            __html: props.shortActionName
        }}
    />
);

Title.propTypes = {
    isLongText: PropTypes.bool.isRequired,
    isExtraLongText: PropTypes.bool.isRequired,
    shortActionName: PropTypes.string,
    onPartnerClick: PropTypes.func
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/Donation/Title.jsx